import moment from 'moment';

import {
  ONBOARDING_REASON,
  ONBOARDING_REASON_LABELS,
  OPERATOR_ACTOR_PREFIX,
  QUEUE_DATE_FORMAT,
  QUEUE_ERROR_FALLBACK,
  STATUS_LABELS,
  VALUE_PLACEHOLDER,
  WALL_CLOCK_DISPLAY_FORMAT,
  WALL_CLOCK_PARSE_FORMAT,
} from '../constants/onboardingQueue';

const wallClockMoment = value => {
  if (!value) return null;
  const parsed = moment(value, [WALL_CLOCK_PARSE_FORMAT, QUEUE_DATE_FORMAT], true);
  return parsed.isValid() ? parsed : null;
};

export const wallClockDate = value => {
  const parsed = wallClockMoment(value);
  return parsed ? parsed.format(QUEUE_DATE_FORMAT) : VALUE_PLACEHOLDER;
};

export const wallClockDateTime = value => {
  const parsed = wallClockMoment(value);
  return parsed ? parsed.format(WALL_CLOCK_DISPLAY_FORMAT) : VALUE_PLACEHOLDER;
};

export const daysAgoLabel = (createdAt, now = moment()) => {
  const parsed = wallClockMoment(createdAt);
  if (!parsed) return VALUE_PLACEHOLDER;

  const days = moment(now).startOf('day').diff(parsed.startOf('day'), 'days');
  if (days <= 0) return 'today';
  if (days === 1) return '1 day ago';
  return `${days} days ago`;
};

export const operatorLabel = updatedBy => {
  if (!updatedBy) return VALUE_PLACEHOLDER;

  const actor = updatedBy.startsWith(OPERATOR_ACTOR_PREFIX)
    ? updatedBy.slice(OPERATOR_ACTOR_PREFIX.length)
    : updatedBy;
  return actor.trim() || VALUE_PLACEHOLDER;
};

export const statusLabel = status => {
  if (!status) return VALUE_PLACEHOLDER;
  return STATUS_LABELS[status] || status;
};

export const contactInfo = (email, phone) => ({
  email: email || VALUE_PLACEHOLDER,
  phone: phone || VALUE_PLACEHOLDER,
});

export const toDateBound = bound => {
  if (!bound || !moment.isMoment(bound) || !bound.isValid()) return null;
  return bound.format(QUEUE_DATE_FORMAT);
};

export const queueErrorMessage = error => {
  const message = error && error.message ? String(error.message).trim() : '';
  return message || QUEUE_ERROR_FALLBACK;
};

export const reasonLabel = reason => {
  if (!reason) return VALUE_PLACEHOLDER;
  return ONBOARDING_REASON_LABELS[reason] || reason;
};

export const toReasonSelection = reason => {
  const stored = reason == null ? '' : String(reason);
  if (!stored) return { reason: null, otherText: '' };
  if (ONBOARDING_REASON_LABELS[stored]) return { reason: stored, otherText: '' };
  return { reason: ONBOARDING_REASON.OTHER, otherText: stored };
};

export const attemptCount = record => {
  const count = record ? record.noteCount : null;
  return typeof count === 'number' && Number.isFinite(count) ? count : VALUE_PLACEHOLDER;
};

export const coverageStartDate = (now = moment()) => (
  moment(now).startOf('day').add(1, 'day').format(QUEUE_DATE_FORMAT)
);

export const mutationErrorMessage = (payload, error) => {
  const messages = payload && Array.isArray(payload.errors) ? payload.errors : [];
  const joined = messages.map(message => String(message).trim()).filter(Boolean).join(' ');
  return joined || queueErrorMessage(error);
};

export const hasAgreedPrice = price => typeof price === 'number' && Number.isFinite(price);

export const priceProps = price => ({
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  value: price,
});
